import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PartnerCostModal from "./PartnerCostModal";
import PartnerCostComboModal from "./PartnerCostComboModal";
import { INITPAGING } from "../based/Constants";
import PartnerServices from "../based/services/PartnerServices";
import { ConfirmDialog } from "../based/Dialog";

function PartnerCostManage(props) {
    //discount thường
    const [modalId, setModalId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [listModel, setListModel] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });

    //discount khi chọn combo
    const [modalComboId, setModalComboId] = useState(0);
    const [showModalCombo, setShowModalCombo] = useState(false);
    const [listModelCombo, setListModelCombo] = useState([]);
    const [pagingCombo, setPagingCombo] = useState({ ...INITPAGING });

    console.log("listModelCombo", listModelCombo);

    useEffect(() => {
        getData(paging);
        getDataCombo(pagingCombo);
    }, []);

    const getData = async (page) => {
        const [err, data] = await PartnerServices.GetAppPartnerCostDiscountByPage(page);
        if (!err && data) {
            setListModel(data.listObjects);
            setPaging(data.paging);
        } else {
            setListModel([]);
            setPaging({ ...INITPAGING });
        }
    };

    const getDataCombo = async (page) => {
        const [err, data] = await PartnerServices.GetPartnerCostDiscountCombo(page);
        if (!err && data) {
            setListModelCombo(data.listObjects);
            setPagingCombo(data.paging);
        } else {
            setListModelCombo([]);
            setPagingCombo({ ...INITPAGING });
        }
    };

    const handleRemove = async (id, isSingle = true) => {
        new ConfirmDialog("Xác nhận xóa", "Bạn có chắc chắn muốn xóa không?", () => {
            return new Promise(async (resolve, reject) => {
                const [err, data] = await PartnerServices.RemovePartnerCostDiscount(id);
                if (!err && data) {
                    if (isSingle) getData(paging);
                    else getDataCombo(pagingCombo);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                }
            });
        });
    };

    function renderContentBody() {
        const content = [];
    }

    return (
        <React.Fragment>
            <Wrapper>
                <section className="table-cost-single">
                    <table className="table table-bordered table-single">
                        <thead>
                            <tr>
                                <th className="center">Loại phí</th>
                                <th className="center">Tên phí</th>
                                <th className="center">Shop thường</th>
                                <th className="center">Shop mall</th>
                                <th className="center">Nội dung</th>
                                <th className="center">Link chi tiết</th>
                                <th className="center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listModel && listModel.length > 0 ? (
                                listModel.map((item, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td className="vertical-align-middle">{item.discountTypeName}</td>
                                            <td className="vertical-align-middle">{item.name}</td>
                                            <td className="center cost">{item.partnerCostDiscountValue && item.partnerCostDiscountValue.normalShopValue}%</td>
                                            <td className="center cost">{item.partnerCostDiscountValue && item.partnerCostDiscountValue.mallShopValue}%</td>
                                            <td className="vertical-align-middle">{item.description}</td>
                                            <td className="vertical-align-middle link-detail">
                                                <a href={item.linkDetail} target="_blank">
                                                    {item.linkDetail}
                                                </a>
                                            </td>
                                            <td>
                                                <div className="list-btn">
                                                    <button
                                                        className="btn btn-custom m-1"
                                                        onClick={(e) => {
                                                            setShowModal(true);
                                                            setModalId(item.id);
                                                        }}
                                                    >
                                                        Sửa
                                                    </button>
                                                    <button
                                                        className="btn btn-danger m-1"
                                                        onClick={(e) => {
                                                            handleRemove(item.id);
                                                        }}
                                                    >
                                                        Xóa
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={999}>Hiện không có dữ liệu</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <a
                        href=""
                        className="text text-custom"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                            setModalId(0);
                        }}
                    >
                        Thêm phí <i className="fa fa-fa-plus" />
                    </a>
                </section>
                <section className="table-cost-combo">
                    <table className="table table-bordered table-combo">
                        <thead>
                            <tr>
                                <th className="center">Loại phí</th>
                                <th className="center">Tên phí Combo</th>
                                <th className="center">Các phí trong Combo</th>
                                <th className="center">Shop thường</th>
                                <th className="center">Shop mall</th>
                                <th className="center">Nội dung</th>
                                <th className="center">Link chi tiết</th>
                                <th className="center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listModelCombo && listModelCombo.length > 0 ? (
                                listModelCombo.map((item, idx) => {
                                    const firstSingle = item.listSingleItem && item.listSingleItem.length > 0 ? item.listSingleItem[0] : {};
                                    const listAnotherSingle = item.listSingleItem && item.listSingleItem.length > 0 ? item.listSingleItem.slice(1) : [];
                                    var rowSpan = item.listSingleItem && item.listSingleItem.length > 0 ? item.listSingleItem.length : 1;
                                    return (
                                        <React.Fragment key={idx}>
                                            <tr>
                                                <td className="vertical-align-middle" rowSpan={rowSpan}>
                                                    {item.discountTypeName}
                                                </td>
                                                <td className="vertical-align-middle" rowSpan={rowSpan}>
                                                    {item.name}
                                                </td>
                                                <td className="vertical-align-middle">{firstSingle && firstSingle.name}</td>
                                                <td className="center cost">{firstSingle && firstSingle.partnerCostDiscountValue ? firstSingle.partnerCostDiscountValue.normalShopValue : 0}%</td>
                                                <td className="center cost">{firstSingle && firstSingle.partnerCostDiscountValue ? firstSingle.partnerCostDiscountValue.mallShopValue : 0}%</td>
                                                <td className="vertical-align-middle" rowSpan={rowSpan}>
                                                    {item.description}
                                                </td>
                                                <td className="vertical-align-middle link-detail" rowSpan={rowSpan}>
                                                    <a href={item.linkDetail} target="_blank">
                                                        {item.linkDetail}
                                                    </a>
                                                </td>
                                                <td rowSpan={rowSpan}>
                                                    <div className="list-btn">
                                                        <button
                                                            className="btn btn-custom m-1"
                                                            onClick={(e) => {
                                                                setModalComboId(item.id);
                                                                setShowModalCombo(true);
                                                            }}
                                                        >
                                                            Sửa
                                                        </button>
                                                        <button
                                                            className="btn btn-danger m-1"
                                                            onClick={(e) => {
                                                                handleRemove(item.id);
                                                            }}
                                                        >
                                                            Xóa
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            {listAnotherSingle &&
                                                listAnotherSingle.length > 0 &&
                                                listAnotherSingle.map((itemSingle, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className="vertical-align-middle">{itemSingle.name}</td>
                                                            <td className="center cost">{itemSingle.partnerCostDiscountValue ? itemSingle.partnerCostDiscountValue.normalShopValue : 0}%</td>
                                                            <td className="center cost">{itemSingle.partnerCostDiscountValue ? itemSingle.partnerCostDiscountValue.mallShopValue : 0}%</td>
                                                        </tr>
                                                    );
                                                })}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={999}>Hiện không có dữ liệu</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <a
                        href=""
                        className="text text-custom"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowModalCombo(true);
                            setModalComboId(0);
                        }}
                    >
                        Thêm phí Combo <i className="fa fa-fa-plus" />
                    </a>
                </section>
            </Wrapper>
            <PartnerCostModal
                show={showModal}
                onClose={() => {
                    setShowModal(false);
                }}
                onSave={() => {
                    setShowModal(false);
                    getData(paging);
                }}
                modalId={modalId}
            />
            <PartnerCostComboModal
                show={showModalCombo}
                onClose={() => {
                    setShowModalCombo(false);
                }}
                onSave={() => {
                    setShowModalCombo(false);
                    getDataCombo(pagingCombo);
                }}
                modalComboId={modalComboId}
            />
        </React.Fragment>
    );
}

export default PartnerCostManage;

const Wrapper = styled.div`
    background: #fff;

    section.table-cost-single {
        padding: 20px 24px;
    }

    table.table.table-bordered.table-single thead {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    td.cost {
        font-weight: 600;
    }

    section.table-cost-combo {
        padding: 20px 24px;
    }

    table.table.table-bordered.table-combo thead {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }
`;
